import { BrandingComponent } from './widgets/branding/branding.component';
import { NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { TwoFactorAuthMonitorComponent } from '../routes/components/two-factor-auth/two-factor-auth-monitor/two-factor-auth-monitor.component';

import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { HeaderComponent } from './header/header.component';
import { ThemeToggleComponent } from './header/theme-toggle/theme-toggle.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarLogoComponent } from './sidebar/sidebar-logo/sidebar-logo.component';
import { UserPanelComponent } from './sidebar/user-panel.component';
import { VersionDialogComponent } from './sidebar/version-dialog/version-dialog.component';
import { SidebarNoticeComponent } from './sidebar-notice/sidebar-notice.component';
import { NavAccordionDirective } from './sidemenu/nav-accordion.directive';
import { NavAccordionItemDirective } from './sidemenu/nav-accordion-item.directive';
import { NavAccordionToggleDirective } from './sidemenu/nav-accordion-toggle.directive';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { TopmenuComponent } from './topmenu/topmenu.component';
import { TopmenuPanelComponent } from './topmenu/topmenu-panel.component';
import { NotificationComponent } from './widgets/notification/notification.component';
import { TranslateComponent } from './widgets/translate/translate.component';
import { UserComponent } from './widgets/user/user.component';

@NgModule({
    imports: [SharedModule, NgOptimizedImage, TwoFactorAuthMonitorComponent, AdminLayoutComponent,
        AuthLayoutComponent,
        SidebarComponent,
        UserPanelComponent,
        SidemenuComponent,
        NavAccordionDirective,
        NavAccordionItemDirective,
        NavAccordionToggleDirective,
        SidebarNoticeComponent,
        TopmenuComponent,
        TopmenuPanelComponent,
        HeaderComponent,
        BrandingComponent,
        NotificationComponent,
        TranslateComponent,
        UserComponent,
        VersionDialogComponent,
        ThemeToggleComponent,
        SidebarLogoComponent],
})
export class ThemeModule {}
